const formatUser = userData => {
  // fix mismatch between local format and server format
  return {
    ...userData,
    customerAccount: {
      ...(userData.customerAccount || {}),
      firstAndLastName: `${userData?.customerAccount?.firstName} ${userData?.customerAccount?.lastName}`,
      postCode: userData?.customerAccount?.postalCode,
      email: userData?.customerAccount?.emailAddress,
      customerNumber: userData?.id,
    },
  }
}

export default formatUser
